module.exports = __webpack_public_path__ + "img/order-success.20a00ff9.png";